// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1822":"97bb36c0","4272":"1186272a","5982":"0ca5ebf0","7667":"f1576439"}[chunkId] + ".chunk.css";
};